import { Trans } from "@lingui/react/macro"
import React from "react"

import Button from "../../../../../design-system/button"
import FeatherIcon from "../../../../../design-system/feather-icon"
import Paragraph from "../../../../../design-system/paragraph"
import { getCoreUrl } from "../../../../../utils/urls"
import * as styles from "./index.module.scss"

type Props = {
  disabled?: boolean
}

function DownloadCatalogButton({ disabled }: Props) {
  return (
    <Button
      as="a"
      href={getCoreUrl("/catalog-file.csv?charities=true")}
      variant="link"
      disabled={disabled}
      className={styles.downloadLink}
      trackingProperties={{
        buttonName: "Download catalog",
        buttonLocation: "body",
        buttonPosition: "1",
      }}
      data-testid="download-catalog-button"
    >
      <FeatherIcon type="download" />
      <Paragraph variant="2" className={styles.downloadText}>
        <Trans>Download catalog</Trans>
      </Paragraph>
    </Button>
  )
}

export default DownloadCatalogButton
